module.exports = __webpack_public_path__ + "img/HC1012-159.3c3086e7.jpg";